import type { Value } from 'modules/core/components/MultiFilters/hooks/utils/defaultEvaluators'
import { employeeLegalEntityId } from 'modules/core/lib/employeeLegalEntity'
import users from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import { supplementEmployee } from 'modules/payroll_bundle/lib/supplementEmployee'
import type Supplement from 'modules/payroll_bundle/store/models/Supplement'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { employeeTeams } from 'modules/teams/store/employeeTeams'

export default (supplement: Supplement, fieldName: Value) => {
  if (
    !supplement.attributes.employee_id &&
    !(supplement.has('userId') && supplement.attributes.userId)
  ) {
    return true
  }

  let employee = supplementEmployee(supplement, employees)

  if (!employee && supplement.has('userId')) {
    const user = users.find({
      id: supplement.attributes.userId,
    })
    employee =
      user && !user.isNew
        ? employees.find({
            access_id: user.attributes.id,
          })
        : undefined
  }

  if (!employee) return

  switch (fieldName) {
    case 'employee_status':
      return employee

    case 'employee_name':
      return users.get(employee.attributes.access_id)?.fullName()

    case 'location':
      return employee.attributes.location_id

    case 'team':
      return employeeTeams(teams, memberships, employee.id).map((team) => team.attributes.id)

    case 'legal_entity':
      return employeeLegalEntityId(employee)
  }
}
